import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card,Badge, NavBar, Space, Result, NoticeBar } from 'antd-mobile'
import { 
  PhonebookOutline,
  UserAddOutline,
  UserContactOutline,
  TeamOutline,
  MessageOutline,
  UserCircleOutline,
  BillOutline,
  BankcardOutline,
  HandPayCircleOutline,
  MovieOutline,
  FlagOutline
} from 'antd-mobile-icons'
import { showConfirm } from '../../utils/util'
import api from '../../https/api';
import './index.scss'

export default function Index() {
  const {state} = useLocation()
  const navigate = useNavigate()
  //const {userid} = useParams()
  const [userid,setUserid] = useState(null)
  const [userinfo,setUserinfo] = useState({})
  const [signerList,setSignerList] = useState([])
  const [desc,setDesc] = useState('账户登录中...')
  const [notice,setNotice] = useState({status:false,text:''})
  const [total,setTotal] = useState({pending:0,sign:0,exam:0,reject:0,appeal:0})

  useEffect(()=>{
    const fetchData = async () => {
      if(state && state.userid > 0){
        const {data:{code,data,msg}} = await api.getUserinfo(state.userid)
        if(code === 0){
          setUserid(data.id)
          setTotal(data.total)
          setSignerList(data.signer_list)
          setNotice(data.notice)
          setUserinfo(data)
          data.signer_list = []
          data.notice = []
          
          localStorage.setItem('crm_client_userinfo',btoa(JSON.stringify(data)))
        }else{
          setDesc(msg)
        }
      }else{
        setDesc('请在企业微信内打开应用')
      }
    }
    fetchData()
  },[state])

  const right = (
    <div style={{ fontSize: 24 }}>
      <Space style={{ '--gap': '16px' }}>
        <UserCircleOutline onClick={() => logout()}/>
      </Space>
    </div>
  )

  const logout = async () => {
    const confirm = await showConfirm('确定要退出吗')
    if(!confirm) return
    localStorage.removeItem('crm_client_userinfo')
    setTimeout(() => {
      navigate(`/`)
    }, 500);
  }
  return (
    <div className='index'>
      <NavBar backArrow={false} right={right} className="crm-header">首页</NavBar>
      {
        notice.status? (
          <NoticeBar content={notice.text} color='alert' closeable />
        ) : null
      }
      {
        userinfo.id ? (
          <>
            {
              userinfo.job.includes(6) ? (
                <Card title='房贷返佣' bodyClassName="crm-card" headerClassName="card-title">
                  <div className='item' onClick={()=>{navigate('/business/houseBrokerageOrder')}}>
                    <BillOutline fontSize={36}/>
                    <div className='desc' style={{fontSize:'12px'}}>返佣申请单</div>
                  </div>
                </Card>
              ) : (
                <>
                  <Card title='分期业务' bodyClassName="crm-card" headerClassName="card-title">
                    <Space wrap justify="start">
                        <div className='item' onClick={()=>{navigate(`/business/pending`)}}>
                          <Badge content={total.pending}>
                            <PhonebookOutline fontSize={36}/>
                            <div className='desc'>待跟进</div>
                          </Badge>
                        </div>
                        <div className='item' onClick={()=>{navigate(`/business/list`)}}>
                          <UserContactOutline fontSize={36}/>
                          <div className='desc'>我的进件</div>
                        </div>
                        <div className='item' onClick={()=>{navigate(`/business/add`)}}>
                          <UserAddOutline fontSize={36}/>
                          <div className='desc'>新增进件</div>
                        </div>
                        <div className='item' onClick={()=>{navigate('/business/reject')}}>
                          <div className='my-icon'><i className='iconfont icon-dingdanbohui'></i></div>
                          <div className='desc'>签约驳回</div>
                        </div>
                        <div className='item' onClick={()=>{navigate('/business/proof')}}>
                          <div className='my-icon'><i className='iconfont icon-yibaopingzheng'></i></div>
                          <div className='desc'>凭证驳回</div>
                        </div>
                        <div className='item' onClick={()=>{navigate(`/business/ysb`)}}>
                          <div className='my-icon'><i className='iconfont icon-xiaochengxu'></i></div>
                          <div className='desc'>意数宝</div>
                        </div>
                        {
                          userinfo.job.includes(3) ? (
                            <div className='item' onClick={()=>{navigate(`/business/service`)}}>
                              <Badge content={total.service}>
                                <div className='my-icon'><i className='iconfont icon-kefu'></i></div>
                                <div className='desc'>客服协助</div>
                              </Badge>
                            </div>
                          ) : null
                        }
                        <div className='item' onClick={()=>{navigate(`/business/stat`)}}>
                          <div className='my-icon'><i className='iconfont icon-tongji1'></i></div>
                          <div className='desc'>业务统计</div>
                        </div>
                        {/* {
                          [4,5,14,497,326].includes(userinfo.id) && (
                            <div className='item' onClick={()=>{navigate(`/activity/demo`)}}>
                              <FlagOutline fontSize={36}/>
                              <div className='desc'>活动中心</div>
                            </div>
                          )
                        } */}
                        {/* <div className='item' onClick={()=>{navigate(`/business/signin`)}}>
                          <CameraOutline fontSize={36}/>
                          <div className='desc'>签到打卡</div>
                        </div> */}

                        {
                          [4,5,337,169,379,312,353,295,383,223,185,306,308,286,288,165,299,15,167].includes(userinfo.id) && userinfo.elife && (
                            <div className='item' onClick={()=>{navigate(`/activity/elife/qrcode`)}}>
                              <BankcardOutline fontSize={36}/>
                              <div className='desc'>融e借</div>
                            </div>
                          )
                        }
                        
                    </Space>
                  </Card>
                  <Card title='房贷业务' bodyClassName="crm-card" headerClassName="card-title">
                    <Space wrap justify="start">
                      <div className='item' onClick={()=>{navigate(`/business/house`)}}>
                        <div className='my-icon'><i className='iconfont icon-fangdai'></i></div>
                        <div className='desc'>房贷数据</div>
                      </div>
                      <div className='item' onClick={()=>{navigate(`/business/houseAdd`)}}>
                        <UserAddOutline fontSize={36}/>
                        <div className='desc'>房贷进件</div>
                      </div>
                      {
                        [4,5,14,497,326,611].includes(userinfo.id) && (

                          <div className='item' onClick={()=>{navigate(`/business/houseAgent`)}}>
                            <Badge content="经">
                              <UserAddOutline fontSize={36}/>
                              <div className='desc'>经纪业务</div>
                            </Badge>
                          </div>
                        )
                      }
                      <div className='item' onClick={()=>{navigate(`/business/houseChannel`)}}>
                        <div><i className='iconfont icon-qudao_huaban'></i></div>
                        <div className='desc'>房贷渠道</div>
                      </div>
                      <div className='item' onClick={()=>{navigate(`/business/houseBankManager`)}}>
                        <div className='my-icon'><i className='iconfont icon-jingli'></i></div>
                        <div className='desc'>客户经理</div>
                      </div>
                      <div className='item' onClick={()=>{navigate(`/business/houseBrokerageUser`)}}>
                        <BankcardOutline fontSize={36}/>
                        <div className='desc'>返佣账户</div>
                      </div>
                      <div className='item' onClick={()=>{navigate(`/business/houseRecommendList`)}}>
                        <div className='my-icon'><i className='iconfont icon-youxuanfangyuan'></i></div>
                        <div className='desc'>优选房源</div>
                      </div>

                      {
                        userinfo.job.includes(4) ? (
                          <>
                            <div className='item' onClick={()=>{navigate('/business/houseBrokerage')}}>
                              <HandPayCircleOutline fontSize={36}/>
                              <div className='desc'>返佣数据</div>
                            </div>
                          </>
                        ) : null
                      }
                      {
                        userinfo.job.includes(4) ? (
                          <Space>
                            <div className='item' onClick={()=>{navigate('/business/houseBrokerageOrder')}}>
                              <BillOutline fontSize={36}/>
                              <div className='desc' style={{fontSize:'12px'}}>返佣申请单</div>
                            </div>
                            {/* <div className='item' onClick={()=>{navigate('/business/financeAudit')}}>
                              <div className='my-icon'><i className='iconfont icon-jurassic_audit-something'></i></div>
                              <div className='desc' style={{fontSize:'12px'}}>超额度审批</div>
                            </div> */}
                            <div className='item' onClick={()=>{navigate('/business/financeAuditNew')}}>
                              <div className='my-icon'><i className='iconfont icon-jurassic_audit-something'></i></div>
                              <div className='desc' style={{fontSize:'12px'}}>提额审批</div>
                            </div>
                          </Space>
                        ) : null
                      }
                      {
                        [14,326,611].includes(userinfo.id) && (
                          <div className='item' onClick={()=>{navigate('/business/financeAuditNew')}}>
                            <div className='my-icon'><i className='iconfont icon-jurassic_audit-something'></i></div>
                            <div className='desc' style={{fontSize:'12px'}}>提额审批</div>
                          </div>
                        )
                      }
                      
                      {
                        userinfo.job.includes(5) ? (
                          <Space>
                            <div className='item' onClick={()=>{navigate(`/business/houseSign`)}}>
                              <Badge content={total.remind}>
                                <div className='my-icon'><i className='iconfont icon-guanjia'></i></div>
                                <div className='desc'>房贷管家</div>
                              </Badge>
                            </div>
                            <div className='item' onClick={()=>{navigate(`/business/housePhoto`)}}>
                              <div className='my-icon'><i className='iconfont icon-gongzhonghao'></i></div>
                              <div className='desc' style={{fontSize:'12px'}}>公众号数据</div>
                            </div>
                            <div className='item' onClick={()=>{navigate(`/business/houseSignCard`)}}>
                              <div className='my-icon'><i className='iconfont icon-xinyongkafenqi'></i></div>
                              <div className='desc'>卡分期</div>
                            </div>
                          </Space>
                        ) : null
                      }                
                    </Space>
                  </Card>
                  <Card title='考试中心' bodyClassName="crm-card" headerClassName="card-title">
                    <Space wrap justify="start">
                      <div className='item' onClick={()=>{navigate('/exam/center')}}>
                        <Badge content={total.exam}>
                          <div className='my-icon'><i className='iconfont icon-kaoshi'></i></div>
                          <div className='desc'>参加考试</div>
                        </Badge>
                      </div>
                      <div className='item' onClick={()=>{navigate('/exam/list')}}>
                        <div className='my-icon'><i className='iconfont icon-icon-kaoshijilu'></i></div>
                        <div className='desc'>考试回顾</div>
                      </div>
                      {/* {
                        [3,4,5,17].includes(userinfo.id) ? (
                          <div className='item' onClick={()=>{navigate(`/exam/learn`)}}>
                            <MovieOutline fontSize={36}/>
                            <div className='desc'>学习天地</div>
                          </div>
                        ) : null
                      } */}
                    </Space>
                  </Card>
                  {
                    userinfo && userinfo.leader ? (
                      <Card title='团队数据' bodyClassName="crm-card" headerClassName="card-title">
                        <Space wrap justify="start">
                          <div className='item' onClick={()=>{navigate('/team/list')}}>
                            <TeamOutline fontSize={36}/>
                            <div className='desc'>分期业务</div>
                          </div>
                          <div className='item' onClick={()=>{navigate('/team/appeal')}}>
                            <Badge content={total.appeal}>
                              <MessageOutline fontSize={36}/>
                              <div className='desc'>反馈数据</div>
                            </Badge>
                          </div>
                          <div className='item' onClick={()=>{navigate('/team/ysb')}}>
                            <div className='my-icon'><i className='iconfont icon-xiaochengxu'></i></div>
                            <div className='desc'>意数宝</div>
                          </div>
                          <div className='item' onClick={()=>{navigate('/team/house')}}>
                            <div className='my-icon'><i className='iconfont icon-sushejiaofei'></i></div>
                            <div className='desc'>房贷业务</div>
                          </div>
                          {
                            userinfo.job.includes(4) ? (
                              <Space>
                                <div className='item' onClick={()=>{navigate('/team/houseChannel')}}>
                                  <div className='my-icon'><i className='iconfont icon-yuangongfenpei'></i></div>
                                  <div className='desc'>房贷分配</div>
                                </div>
                                <div className='item' onClick={()=>{navigate(`/business/housePhoto`)}}>
                                  <div className='my-icon'><i className='iconfont icon-gongzhonghao'></i></div>
                                  <div className='desc' style={{fontSize:'12px'}}>公众号进件</div>
                                </div>
                              </Space>
                            ) : null
                          }
                        </Space>
                      </Card>
                    ) : null
                  }
                  {
                    userinfo.job && (userinfo.job.includes(2))? (
                      <Card title='签约中心' bodyClassName="crm-card" headerClassName="card-title">
                        <Space wrap justify="start">
                          {
                            userinfo.job.includes(2) ? (
                              <Space>
                                <div className='item' onClick={()=>navigate(`/sign/list/${userinfo.id}/1`)}>
                                  <Badge content={total.sign}>
                                    <div className='my-icon'><i className='iconfont icon-asset_application_for_collar'></i></div>
                                    <div className='desc'>任务中心</div>
                                  </Badge>
                                </div>
                                <div className='item' onClick={()=>navigate(`/sign/list/${userinfo.id}/2`)}>
                                  <div className='my-icon'><i className='iconfont icon-renwuzhongxin'></i></div>
                                  <div className='desc'>我的任务</div>
                                </div>
                              </Space>
                            ) : null
                          }
                          {
                            userid && [29,163].includes(parseInt(userid)) ? (
                              <div className='item' onClick={()=>navigate(`/sign/reject`)}>
                                <Badge content={total.reject}>
                                  <div className='my-icon'><i className='iconfont icon-jurassic_audit-something'></i></div>
                                  <div className='desc'>驳回审批</div>
                                </Badge>
                              </div>
                            ) : null
                          }
                          {
                            signerList.map(item => {
                              return (
                                <div className='item' key={item.id} onClick={()=>navigate(`/sign/list/${item.id}/2`)}>
                                  <div className='my-icon'>
                                    <i className={[42,43].includes(item.id)? 'iconfont icon-nvshi' :'iconfont icon-nanshi'}></i>
                                  </div>
                                  <div className='desc'>{item.name}</div>
                                </div>
                              )
                            })
                          }
                        </Space>
                      </Card>
                    ) : null
                  }
                </>
              )
            }
          </>
        ): (
          <Result
            status='warning'
            title='提示'
            description={desc}
          />
        ) 
      }
    </div>
  )
}
